import Vue from "vue";
import { TrackJS } from "trackjs";
import { JwtHelper } from "@/helpers/utilities/JwtHelper";

const networkMessagesToBeIgnored = () => {
  return [
    /^404 : GET https:\/\/graph\.microsoft\.com\/(\bv1\.0\b|\bbeta\b)\/users\/.*\/photos\/48x48\/\$value$/,
    /^404 : GET https:\/\/graph\.microsoft\.com\/(\bv1\.0\b|\bbeta\b)\/groups\/.*\/owners/, // https://regex101.com/r/SAUAkN/1
    /^404 : GET https:\/\/graph\.microsoft\.com\/(\bv1\.0\b|\bbeta\b)\/groups\/.*\/members/,
    /^400 : GET https:\/\/skobostats.azurewebsites.net\/api\/CustomerAdminUsers/,
    /^403 : GET https:\/\/.*\.sharepoint.com\/.*\/_api\/web\/sitegroups\/GetByName\(.*\)\/users/ // https://regex101.com/r/n3GrFi/1
  ];
};

const promiseMessagesToBeIgnored = () => {
  return [/^Avoided redundant navigation to current location: "\/".$/gm];
};

export default {
  initialize() {
    if (import.meta.env.VITE_APP_DO_TRACK_ERRORS === "true") {
      TrackJS.install({
        token: "9df19a659fd14a02b69d32e31af6111e",
        application: import.meta.env.VITE_APP_TRACKJS_APPLICATION,
        console: { display: import.meta.env.DEV },
        version: import.meta.env.VITE_APP_VERSION,
        onError: function (payload) {
          if (payload && payload.entry === "ajax") {
            if (networkMessagesToBeIgnored().some(rx => rx.test(payload.message))) {
              return false;
            }
          } else if (payload && payload.entry === "promise") {
            if (promiseMessagesToBeIgnored().some(rx => rx.test(payload.message))) {
              return false;
            }
          }

          return true;
        }
      });

      Vue.config.errorHandler = (err, vm, info) => {
        // Log properties passed to the component if there are any
        if (vm.$options.propsData) {
          // eslint-disable-next-line no-console
          console.log("Props passed to component", vm.$options.propsData);
        }

        // Emit component name and also the lifecycle hook the error occurred in if present
        var infoMessage = `Error in component: <${vm.$options.name} />\n`;
        if (info) {
          infoMessage += `Error occurred during lifecycle hook: ${info}\n`;
        }

        // This puts the additional error information in the Telemetry Timeline
        // eslint-disable-next-line no-console
        console.log(infoMessage);

        // Track the native JS error
        TrackJS.track(err);
      };
    }
  },

  setUserFromJwt(token) {
    if (import.meta.env.VITE_APP_DO_TRACK_ERRORS === "true") {
      const userId = JwtHelper.getCustomerId(token) + "/" + JwtHelper.getUserId(token);

      TrackJS.configure({
        userId
      });
    }
  },

  registerError(e, additionalInfo) {
    if (import.meta.env.PROD) {
      // Safety Check
      if (!window.TrackJS) {
        return;
      }

      TrackJS.console.log(additionalInfo);
      TrackJS.track(e);
    }
  },

  registerMessage(m) {
    if (import.meta.env.PROD) {
      TrackJS.track(m);
    }
  },

  networkMessagesToBeIgnored,
  promiseMessagesToBeIgnored
};
